/**
 * React Hook — Bridges the vanilla TS authStore into React.
 *
 * Subscribes to store state changes and triggers re-renders.
 */

import { useState, useEffect } from 'react';
import { authStore } from '../store/authStore';

export function useAuthStore() {
  const [state, setState] = useState(authStore.getState());

  useEffect(() => {
    return authStore.subscribe(() => setState(authStore.getState()));
  }, []);

  return {
    ...state,
    register: authStore.register.bind(authStore),
    login: authStore.login.bind(authStore),
    logout: authStore.logout.bind(authStore),
  };
}
